import { useCallback, useState } from "react";
import { routes } from "../../../app/paths";

export const useExamineInvoice = (invoiceId?: string) => {
  const [windowRef, setWindowRef] = useState<Window | null>(null);

  const openWindow = useCallback(
    (rowId?: string) => {
      if (!invoiceId) return;
      const targetPath = rowId
        ? routes.invoiceExamineRow(invoiceId, rowId)
        : routes.invoiceExamine(invoiceId);

      if (windowRef && !windowRef.closed) {
        windowRef.location.href = targetPath;
        // could set focust to the new window here, but I find it distracting
        // windowRef.focus();
        return;
      }

      const newWindow = window.open(targetPath, "_blank");
      if (newWindow) {
        setWindowRef(newWindow);
      }
    },
    [invoiceId, windowRef],
  );

  const closeWindow = useCallback(() => {
    if (windowRef && !windowRef.closed) {
      windowRef.close();
    }
  }, [windowRef]);

  return { openWindow, closeWindow, windowRef };
};
